import request from '../../utils/request'
import requestBase from '../requesBase'
import OSS from 'ali-oss'
const userinfo = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
const headers = {
  //7026060
  'User-ID': userinfo && userinfo.access ? userinfo.access.userId : '',
  'Access-Token': userinfo && userinfo.access ? userinfo.access.accessToken  : '',
  'APP-Name': 'jianpin_web_editor'
}

function client(token) {
  return new OSS({
      secure: true,
      region: token.region,
      accessKeyId: token.access_key_id,
      accessKeySecret: token.access_key_secret,
      stsToken: token.sts_token,
      bucket: token.bucket,
      endpoint: token.endpoint
  })
}

const uploadModule = {

// 获取阿里云临时token
getSTSToken(data) {
  return request({
      url: 'pc_web/site/sts-token',
      method: 'post',
      data,
      headers
  })
},

// 获取阿里云oss相对路径
getOSSPath(data) {
  return request({
      url: 'pc_web/site/oss-path',
      method: 'post',
      data,
      headers
  })
},

// // 获取阿里云oss相对路径
// getOSSPath(data, callback) {
//   requestBase.post('/site/oss-path', data).then((res) => {
//     callback(res)
//   })
// }

// 获取加密链接
getSignUrl(data) {
  return request({
    url: 'pc_web/site/sign-url',
    method: 'post',
    data,
    headers
  })
},

// 文件上传阿里云，带进度
uploadFile(file, callback, raw, storePrefix) {
    let data = new FormData();
    data.append('is_app', 1);
    const ext = file.name.substring(file.name.lastIndexOf("."));
    const storeAs = storePrefix ? storePrefix : ("jianpin-dh/upload/" + headers["User-ID"] + new Date().getTime() + Math.round(Math.random() * 100) + ext);
    let checkpoint;
    this.getSTSToken(data, headers)
        .then((token) => {
            if (token.data && token.data.code === 200) {
                // console.log("stsToken", res.data.data);
                client(token.data.data).multipartUpload(storeAs, file, {
                    checkpoint,
                    progress(p, cpt) {
                        checkpoint = cpt;
                        callback.onProgress(p);
                    }
                }).then(upRes => {
                    if (upRes.res && upRes.res.status === 200) {
                        const url = "https://" + token.data.data.endpoint + "/" + storeAs;
                        if(raw){
                            callback.onResult(url);
                        }else {
                            let formData = new FormData(); 
                            formData.append("url", url);
                            this.getSignUrl(formData, headers)
                                .then((sigRes) => {
                                    if (sigRes.data && sigRes.data.code === 200) {
                                        callback.onResult(sigRes.data.data);
                                    } else {
                                        callback.onResult(null);
                                    }
                                })
                                .catch(() => {
                                    callback.onResult(null);
                                });
                        }

                    } else {
                        callback.onResult(null);
                    }
                }).catch((err) => {
                    callback.onResult(null);
                });
            } else {
                callback.onResult(null);
            }
        })
        .catch(() => {
            callback.onResult(null);
        });
},

// 文件上传阿里云，带进度
uploadFileV2(file, callback, type) {
  const ext = file.name.substring(file.name.lastIndexOf("."));
  this.getOssMultiUploadFilePath(ext, 1, type).then((res) => {
    if(res && res.data.code === 200) {
      const { path, url } = res.data.data[0]
      const storeAs = path
      let checkpoint;
      const data = new FormData();
      data.append('is_app', 1);
      this.getSTSToken(data, headers).then((token) => {
        if (token.data && token.data.code === 200) {
          client(token.data.data).multipartUpload(
            storeAs,
            file, 
            {
              checkpoint,
              progress(p, cpt) {
                checkpoint = cpt;
                callback.onProgress(p);
              }
            }
          ).then(upRes => {
            if (upRes.res && upRes.res.status === 200) {
              callback.onResult(url);
            } else {
              callback.onResult(null);
            }
          }).catch((err) => {
            callback.onResult(null);
          });
        } else {
          callback.onResult(null);
        }
      }).catch(() => {
        callback.onResult(null);
      });
    }
  })
},

// 添加从视频提取音频任务
videoToAudio(data, callback) {
  requestBase.post('/site/extract-audio', data).then(res => {
      callback(res);
  })
},


//获取从视频提取音频任务结果
getvideoToAudio(data, callback) {
  requestBase.post('/site/extract-audio-result', data).then(res => {
      callback(res);
  })
},

// 获取多个上传文件名
getOssMultiUploadFilePath(type, num, exts) {
    return request({
        url: 'pc_web/site/multi-oss-path',
        method: 'post',
        data: {
            type,
            num,
            file_exts: exts 
        },
        headers
    })
}
}

export default uploadModule;